import { GewinnermittlungsartEnum } from '../v2024';

export const GewinnermittlungsartEnumLabels = {
    _01: '01' as GewinnermittlungsartEnum,
    _02: '02' as GewinnermittlungsartEnum,
    _03: '03' as GewinnermittlungsartEnum,
    _04: '04' as GewinnermittlungsartEnum
};

